import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './DayListItem.css';

interface DayListItemProps {
    label: string;
    count?: number;
    selected: boolean;
    onClick: () => void;
    'data-cy'?: string;
}

const DayListItem: FC<DayListItemProps> = ({label, count, selected, onClick, 'data-cy': dataCy}) => {
    const {t} = useTranslation('timetable');
    return (
        <css.item type="button" $selected={selected} onClick={onClick} data-cy={dataCy}>
            <css.label $selected={selected}>{label}</css.label>
            {count !== undefined && (
                <css.badge $variant={count > 0 ? 'success' : 'error'}>
                    {t('lecturesCount', {count})}
                </css.badge>
            )}
        </css.item>
    );
};

export default DayListItem;
